import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Box, Button, Grid, Typography } from "@mui/material";

import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { object, string } from "yup";
import BranchesCard from "../../components/cards/BranchesCard";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  AddSupplierAddressResponse,
  getSupplierAddresesResponse,
} from "../../models/report.model";
import {
  AddSupplierAddress,
  GetSupplierAddreses,
} from "../../services/report.service";
import AddBranchSkeleton from "./AddBranchSkeleton";
import ModalAddSupplierBranches from "../../components/modals/ModalAddSupplierBranches";

const SupplierBranches = () => {
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [sendConfirmation, setSendConfirmation] = React.useState();
  const [isAddBranchShowed, setShowAddBranches] = React.useState(false);
  const [showAddBranchForm, setshowAddBranchForm] = React.useState(true);

  const [supplierBranches, setSupplierBranches] = React.useState<
    getSupplierAddresesResponse[]
  >([]);

  const [reloadOnDel, setReloadOnDel] = useState<string>();
  const [reloadOnEdit, setReloadOnEdit] = useState<string>();

  const id = window.localStorage.getItem("SUPPLIER_ID");

  const initialValues: any = {
    address: "",
    email: "",
    telNumbers: "",
  };

  const branchesValidation = object().shape({
    address: string()
      .ensure()
      .required("لطفا آدرس را وارد نمایید.")
      .matches(/^(?!\s+$).*/, "لطفا آدرس را صحیح وارد نمایید")
      .max(500, "آدرس نباید بیشتر از 500 کاراکتر باشد."),
    email: string()
      .ensure()
      .max(250, "ایمیل نباید بیشتر از 250 کاراکتر باشد.")
      .email("لطفا ایمیل را صحیح وارد نمایید."),
    telNumbers: string()
      .ensure()
      .required("لطفا شماره تماس را وارد نمایید.")
      .matches(
        /(((0?9)|(\+?989))\d{2}\W?\d{3}\W?\d{4})|(\d{8})/,
        "لطفا شماره تماس را صحیح وارد نمایید"
      ),
  });

  const handleAddbranch = (values: any) => {
    AddSupplierAddressMutate({
      supplierAddressId: 0,
      supplierId: Number(id!),
      address: values.address.trim(),
      email: values.email.trim(),
      telNumbers: values.telNumbers,
    });
    setshowAddBranchForm(false);
  };

  const { mutate: AddSupplierAddressMutate } = useMutation(AddSupplierAddress, {
    onSuccess: (data: AddSupplierAddressResponse) => {
      if (data) {
        GetSupplierAddresesMutate({
          supplierId: Number(id),
        });
      }
    },
    onError: () => { },
  });

  const { isLoading, mutate: GetSupplierAddresesMutate } = useMutation(
    GetSupplierAddreses,
    {
      onSuccess: (data: getSupplierAddresesResponse[]) => {
        if (data) {
          setSupplierBranches(data);
        }
      },
      onError: () => { },
    }
  );

  useEffect(() => {
    GetSupplierAddresesMutate({
      supplierId: Number(id),
    });
  }, [reloadOnDel, reloadOnEdit]);

  useEffect(() => {
    GetSupplierAddresesMutate({
      supplierId: Number(id!),
    });
  }, [sendConfirmation])
  return (
    <>
      <Box
        width={"100%"}
        height={{
          sm: "100vh",
          xs: "100vh",
          md: "85vh",
          lg: "85vh",
          xl: "85vh",
        }}
        border={"1.5px solid #DAE0E4"}
        borderRadius={"5px"}
        padding={"2rem"}
      >
        <Typography
          style={{
            color: "#1D4A87",
            fontSize: "18px",
            width: "fit-content",
            marginTop: "-40px",
            marginRight: "23px",
            background: "#fff",
          }}
        >
          اطلاعات تماس شعب
        </Typography>

        {isLoading ? (
          <AddBranchSkeleton />
        ) : (
          <>
            {/* no address added */}
            {supplierBranches.length === 0 && !isAddBranchShowed && (
              <Grid
                container
                alignItems="center"
                justifyContent={"center"}
                width={"100%"}
                height={"100%"}
                flexDirection={"column"}
              >
                <Grid item marginBottom={"10px"}>
                  <div>
                    <img
                      src="/images/nouser.jpg"
                      alt="no user"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <Typography style={{ color: "#9AAFC4", fontSize: "20px" }}>
                    شعبه ای ثبت نشده است
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    sx={{
                      width: "fitContent",
                      background: "#28A745",
                      color: "#fff",
                      padding: ".7rem 2rem",
                      fontSize: "14px",
                    }}
                    className="btnForm SuccessDefault"
                    onClick={() => setOpenVerifyModal(true)}
                  >
                    افزودن شعبه جدید
                  </Button>
                </Grid>
              </Grid>
            )}

            {/* add branch */}
            {(supplierBranches.length !== 0 || isAddBranchShowed) && (
              <>
                <div style={{ padding: "1rem 2rem", marginBottom: "15px" }}>
                  <AddCircleOutlineIcon
                    className="cursorPointer SuccessDefaultFont"
                    style={{ width: "25px", height: "25px" }}
                    onClick={() => setOpenVerifyModal((prev) => !prev)}
                  />
                  <span
                    className="cursorPointer SuccessDefaultFont"
                    style={{ marginRight: "10px", fontWeight: "bold" }}
                    onClick={() => setOpenVerifyModal((prev) => !prev)}
                  >
                    افزودن شعبه جدید
                  </span>
                </div>
                <ModalAddSupplierBranches
                  openModel={openVerifyModal}
                  setSendConfirmation={setSendConfirmation}
                  setOpenVerifyModal={setOpenVerifyModal}
                />
              </>
            )}

            {/* branches table */}
            {supplierBranches.length > 0 && (
              <Box
                sx={{ marginTop: "20px", height: "60vh ", overflowY: "auto" }}
              >
                {supplierBranches?.length !== 0 &&
                  supplierBranches
                    ?.map((branch) => (
                      <BranchesCard
                        address={branch.address}
                        email={branch.email}
                        telNumbers={branch.telNumbers}
                        supplierAddressId={branch.id}
                        setReloadOnDel={setReloadOnDel}
                        setReloadOnEdit={setReloadOnEdit}
                      />
                    ))
                    .reverse()}
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default SupplierBranches;
